import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Row, Col } from 'react-bootstrap';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

class Add extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'SAVE',
			isRedirect: false,
			showLoader: false,
			showAddModal: false,
			country: '',
			region: ''
		}

		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	selectCountry(val) {
		this.setState({ country: val });
	}

	selectRegion(val) {
		this.setState({ region: val });
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Saving..' });
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('acyear/saverenew', { token: Reqst.Token(formData) }).then(res => {
			if (res['data'].status == '1') {
				document.getElementById("frmAdd").reset();
				notify.show(res['data'].msg, 'success');
				this.setState({ showLoader: false, saveText: 'SAVE' });
				if (this.props.afterFinish) this.props.afterFinish();
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'SAVE' });
			}
		});
	}

	render() {

		const { country, region } = this.state;

		return (
			<div>
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
							<label>Renewal Month & year</label>
							<input type="month" name="i__month" id="i__month" className="form-control input-sm" />
						</Col>
					</Row><br />
					<Row><br />
						<Col md={12} >
							<label>Active Status <span className="text-danger">*</span></label>
							<select name="i__status" id="i__status" className="form-control input-sm" required >
								<option value="1"> Active </option>
								<option value="0"> In Active </option>
							</select>
						</Col>
					</Row><br />
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText != 'SAVE'} >
									<i className="fa fa-check"></i> {this.state.saveText}
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}

}
export default Add;